import { connect } from 'react-redux';
import HeadLine from './HeadLine';

const mapStateToProps = ({
  content: {
    jumbotron: {
      headline: title
    }
  }
}) => ({
  title
});

export default connect(mapStateToProps)(HeadLine);

